/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Intequalsaspect8Inputs */

const de__class_intequalsaspect8 = /** @type {(inputs: _Class_Intequalsaspect8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist gleich`)
};

/**

* @param {_Class_Intequalsaspect8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_intequalsaspect8 = /** @type {((inputs?: _Class_Intequalsaspect8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Intequalsaspect8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_intequalsaspect8(inputs)
});
export { _class_intequalsaspect8 as "_class_IntEQUALSAspect" }